import axios, {AxiosError, AxiosResponse} from 'axios'
import {ChannelIdentity, ChannelLinkPreview} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const CHANNELS_URL = `${API_URL}/api/channels`

const getChannelIdentities = (): Promise<ChannelIdentity[]> =>
  axios
    .get(`${CHANNELS_URL}/identities`)
    .then((response: AxiosResponse<{data: ChannelIdentity[]}>) => response.data.data)

// POST (não GET): o código de vínculo não pode ir na URL, onde vaza em log e em Referer.
const previewChannelLink = (code: string): Promise<ChannelLinkPreview> =>
  axios
    .post(`${CHANNELS_URL}/link-preview`, {code})
    .then((response: AxiosResponse<{data: ChannelLinkPreview}>) => response.data.data)

const confirmChannelLink = (code: string): Promise<void> =>
  axios.post(`${CHANNELS_URL}/identities/confirm`, {code}).then(() => undefined)

const revokeChannelIdentity = (id: number): Promise<void> =>
  axios.delete(`${CHANNELS_URL}/identities/${id}`).then(() => undefined)

// Mensagem clara do backend (ele já devolve o texto certo para cada recusa).
const requestErrorMessage = (error: unknown, fallback: string): string => {
  const message = (error as AxiosError<{message?: string}>)?.response?.data?.message
  return message || fallback
}

export {
  getChannelIdentities,
  previewChannelLink,
  confirmChannelLink,
  revokeChannelIdentity,
  requestErrorMessage,
}
